/**
 * @description：基础方法
 *
 */
import { getParamsObj } from "./InterfaceCalculation";
import h5PlayAudio from "./AudioPlay";
import getAsyncResult from "./promise/getAsyncResult";
import { showCommonLoading, hideCommonLoading, showTips, hideTips } from "./prompt/main";
import { getPosterAjax, callApp, putaoBuy } from "./JSBridge/index";
import publicVar from "./publicData/global_variable";
import request from "./request";
var ua = navigator.userAgent.toLocaleLowerCase();
var openId;
var utils = {

    /**
     * 获取哈希总的参数值
     * @param name
     * @returns {*}
     */
    getHashQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r =
            window.location.hash.split("?") &&
                window.location.hash.split("?").length > 1
                ? window.location.hash.split("?")[1].match(reg)
                : null;
        if (r != null) return r[2];
        else return null;
    },
    /**
     * 删除 url 的某个参数
     * 
     * @param {string} url 想要执行删除参数操作的url 
     * @param {string} parameter 想要删除的参数
     * 
     * @return {string} 删除参数后的url
     */
    removeURLParameter(url, parameter) {
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {
            //参数名前缀
            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            //循环查找匹配参数
            for (var i = pars.length; i-- > 0;) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    //存在则删除
                    pars.splice(i, 1);
                }
            }

            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    },

    /**
     * 获取 url 的某个参数
     * 
     * @param {string} name 想要取的 key 值
     */
    getQueryString: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var value = null;

        value = window.location.search.substr(1).match(reg) ||
            (window.location.hash.split("?") && window.location.hash.split("?").length > 1 ? window.location.hash.split("?")[1].match(reg) : null);

        if (value != null) {
            return value[2];
        } else {
            return null;
        }
    },

    /**
     * 将 JSON 对象转为 url 字符串
     * 
     * @param {object} ojson 需要转化的 json 对象
     * @return {string} 转化后的字符串
     * 
     * 注：encode 过
     */
    setJsonToUrl: function (ojson) {
        if (typeof ojson !== "object") {
            return;
        }

        var s = "",
            name,
            key;
        for (var p in ojson) {
            if (ojson.hasOwnProperty(p)) {
                name = p;
            }
            key = ojson[p];
            s += "&" + name + "=" + encodeURIComponent(key);
        }
        return s.substring(1, s.length);
    },

    appLogin: function (callback, hostPath, needForceLogin) {
        // 登录成功的回调
        var that = this;
        window.appLoginSuccess = function () {
            if (callback && typeof callback === "function") {
                that.getAppParams(function (result) {
                    callback(result);
                });
            }
        }

        // 判断是否需要强制跳转登录，如果是，取消登录之后继续跳转登录
        if (needForceLogin) {
            window.appLoginCancel = function () {
                that.appLogin(callback, hostPath, needForceLogin);
            }
        }

        if (window.appLogin) {
            window.appLogin();
        } else if (window.android && window.android.appLogin) {
            window.android.appLogin();
        } else if (that.isWeiXin() && window.location.pathname.indexOf('ai_course') === -1 && window.location.pathname.indexOf('/onlinepages/course2') === -1) {
            if (!openId) {
                openId = (that.getQueryString("openId")) ? that.getQueryString("openId") : (window.localStorage.getItem("openId") ? window.localStorage.getItem("openId") : "");
            }
            var source = that.getQueryString("source") ? that.getQueryString("source") : "";
            var sourceToken = that.getQueryString("sourceToken") ? that.getQueryString("sourceToken") : "";
            var curUrl = window.location.href + (window.location.href.indexOf("?") === -1 ? "?" : "&") + "v=" + Math.random();
            let _url = `https://www.putaoabc.com/onlinepages/mph5/?openId=${openId}${source ? "&source=" + source : ""}${sourceToken ? "&sourceToken=" + sourceToken : ""}&url=${encodeURIComponent(curUrl)}#/page/register`;
            window.location.replace(
                `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3ac95cbd0df1881d&redirect_uri=${encodeURIComponent(_url)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
            );
        } else if (window.webkit && window.webkit.messageHandlers) {
            that.ios8IntoVariable("appLogin");
        } else if (that.isPc() || window.location.pathname.indexOf('ai_course') !== -1 || window.location.pathname.indexOf('/onlinepages/course2') !== -1) {    //走pc流程，从cookie取) {
            if (
                window.location.href.indexOf("#/login") < 0 &&
                window.location.href.indexOf("#/register") < 0
            ) {
                window.location.replace(
                    `${hostPath || "/ai_course/"}#/login?url=${encodeURIComponent(window.location.href)}&login_from=pc`
                );
            }
        }
    },

    /**
     * 异布加载js
     * @param {*} callback 
     * @param {*} paramsObj 
     */
    loadJS(url, callback, failCallback) {
        var headElement = document.querySelector('head');

        if (headElement) {
            var script = document.createElement('script');
            script.type = "text/javascript";
            script.src = url;
            headElement.appendChild(script);
            if (typeof callback !== "undefined") {
                if (script.readyState) {
                    script.onreadystatechange = function () {
                        if (script.readyState === "loaded" || script.readyState === "complete") {
                            script.onreadystatechange = null;
                            callback();
                        }
                    }
                } else {
                    script.onload = function () {
                        callback();
                    }
                    script.onerror = function () {
                        if (failCallback && typeof failCallback === "function") {
                            failCallback({
                                "code": 1000,
                                "name": "JS 引入失败！"
                            });
                        }
                    }
                }
            }
        }
    },

    /**
     * 异布加载css
     * @param {*} callback
     * @param {*} failCallback
     */
    loadCSS(url, callback, failCallback) {
        var headElement = document.querySelector('head');

        if (headElement) {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = url;
            headElement.appendChild(link);
            if (typeof callback !== "undefined") {
                if (link.readyState) {
                    link.onreadystatechange = function () {
                        if (link.readyState === "loaded" || link.readyState === "complete") {
                            link.onreadystatechange = null;
                            callback();
                        }
                    }
                } else {
                    link.onload = function () {
                        callback();
                    }
                    link.onerror = function () {
                        if (failCallback && typeof failCallback === "function") {
                            failCallback({
                                "code": 1000,
                                "name": "css 引入失败！"
                            });
                        }
                    }
                }
            }
        }
    },

    /**
    * 获取 putaoid 和 token 等（app、pc）
    * 
    * @param {function} callback 拿到参数后的回调
    * @param {objcet} paramsObj 需要参与计算的参数
    * @param {objcet} noNeedLogin 需要参与计算的参数
    * 
    * 注：token 是未 encode 过的
    * 
    */
    getAppParams: function (callback, paramsObj, hostPath, noNeedLogin) {
        var that = this;
        var UA = navigator.userAgent.toLocaleLowerCase();
        var sendArgs = paramsObj && typeof paramsObj === "object" ? paramsObj : {};
        var callbackAppFlag = false;   // app 回调的标志，如果失败需要上报
        var callbackAppFlagTimer;

        callbackAppFlagTimer = setTimeout(function () {
            if (!callbackAppFlag) {
                if (that.isApp()) {
                    try {
                        var _from = "";
                        if (UA.indexOf('apad') > -1) {
                            _from = "android_pad";
                        } else if (UA.indexOf('aphone') > -1) {
                            _from = "android";
                        } else if (UA.indexOf('iphone') > -1) {
                            _from = "iPhone";
                        } else if (UA.indexOf('ipad') > -1) {
                            _from = "iPad";
                        }
                        var errUrl = "/pb_onlinepages_error/cl.gif?name=except&type=7&putaoid=-2&from=" + _from;
                        var opts = {
                            method: "POST",   //请求方法
                            body: JSON.stringify({
                                type: 'appBridgeEx',
                                url: window.location.href,
                                info: "not window.sendGrapes",
                                stack: UA
                            }),   //请求体
                        }
                        fetch(new Request(errUrl, opts))
                            .then(function (response) {
                                return response.text();
                            })
                            .then(function (responseText) {
                                // console.log('responseText:', responseText);
                            });
                    } catch (err) { }
                }
                that.getAppParams(callback, paramsObj);
            }
        }, 500);

        window.getGrapesUrlResult = function (result) {
            window.getGrapesUrlResult = null;
            clearTimeout(callbackAppFlagTimer);
            if ((result && result.from && result.putaoid && result.token && callback && typeof callback === "function") || noNeedLogin) {
                window.localStorage.setItem("putaoid", result.putaoid || '');
                callback(result);
            } else {
                // 未登录，调用登录方法
                that.appLogin(function () {
                    that.getAppParams(callback, paramsObj);
                });

                try {
                    window.PTMonitor.report({
                        type: 'appBridgeEx',
                        url: window.location.href,
                        info: "getAppParams App 回调数据有误！",
                        stack: UA
                    }, window.EX_TYPE.appBridgeEx);
                } catch (err) { }
            }
        };
        var uuid;
        if (UA.indexOf("micromessenger") > -1 && window.location.pathname.indexOf('ai_course') === -1 && window.location.pathname.indexOf('/onlinepages/course2') === -1) { //微信里面是走的openId
            clearTimeout(callbackAppFlagTimer);
            const paramsStr = getParamsObj("weixin");
            uuid = window.localStorage.getItem("uuid") ? window.localStorage.getItem("uuid") : "";
            if (!uuid) {
                uuid = that.generateUUID();
                window.localStorage.setItem("uuid", uuid);
            }
            openId = (that.getQueryString("openId")) ? that.getQueryString("openId") : (window.localStorage.getItem("openId") ? window.localStorage.getItem("openId") : "")
            if (openId) {
                paramsStr.openId = openId;
                callback(paramsStr);
            } else {
                that.getWeixinOpenId(function (openId) {
                    paramsStr.openId = openId;
                    openId = openId;
                    callback(paramsStr);
                });
            }
        } else if (window.sendGrapes) {
            if (UA.indexOf("android") > -1) {
                sendArgs = JSON.stringify(sendArgs);
            }
            window.sendGrapes(sendArgs);
        } else if (window.android && window.android.sendGrapes) {
            if (UA.indexOf("android") > -1) {
                sendArgs = JSON.stringify(sendArgs);
            }
            window.android.sendGrapes(sendArgs);
        } else if (window.webkit && window.webkit.messageHandlers) {
            that.ios8IntoVariable("sendGrapes", sendArgs);
        } else if (!that.isApp() || window.location.pathname.indexOf('ai_course') !== -1 || window.location.pathname.indexOf('/onlinepages/course2') !== -1) {    //走pc流程，从cookie取
            clearTimeout(callbackAppFlagTimer);
            const paramsStr = getParamsObj();
            var putaoid = that.getCookie("putaoid") ? that.getCookie("putaoid") : that.getQueryString('putaoid');
            var token = that.getCookie("token") ? that.getCookie("token") : that.getQueryString('token');
            uuid = that.getCookie("uuid") ? that.getCookie("uuid") : '';
            if (!uuid) {
                uuid = that.generateUUID();
            }
            if ((putaoid && token && callback && typeof callback === "function") || noNeedLogin) {
                // var result = sendArgs;
                // callback(Object.assign(result, paramsStr));
                callback(paramsStr);
            } else {
                // 未登录，调用登录方法
                that.appLogin(null, hostPath);
            }
        }
    },

    /**
     * 校验是否登录
     * userData 用户验签的数据结构
     * isLogin 已登录的回调
     * noLogin 未登录的回调
     * fail 失败的回调
     */
    checkLogin: function (data) {
        const { userData, isLogin, noLogin, fail } = data;
        const checkFun = (userData) => {
            request("/course_v2/situation/user/info", userData, {
                method: "GET"
            })
                .then((res) => res.json())
                .then((res) => {
                    if (res && res.code === 200) {
                        isLogin && isLogin();
                    } else if (res && res.code === 499) {
                        noLogin || this.appLogin(() => {
                            isLogin && isLogin();
                        }, this.isVipBingo() ? "/bingo/vip_course/" : "");
                    } else {
                        fail || utils.showTips("网络异常，请重试！");
                    }
                });
        }
        if (userData) {
            checkFun(userData);
        } else {
            this.getAppParams((userData) => {
                checkFun(userData);
            });
        }
    },

    /**
     * 
     * @param {*} name 
     * 通过sendgrapes拿到app内参数
     */
    sendGrapes: function (params) {
        var new_params = JSON.stringify(params);
        var ua = navigator.userAgent.toLocaleLowerCase();
        if (window.sendGrapes) {
            if (ua.indexOf("android") > -1) {
                window.sendGrapes(new_params)
            } else {
                window.sendGrapes(params)
            }
        } else if (window.android && window.android.sendGrapes) {
            window.android.sendGrapes(new_params);
        } else if (window.webkit && window.webkit.messageHandlers) {
            this.ios8IntoVariable("sendGrapes", params);
        }
    },

    // ios8 方法调用需要通过发请求的方式
    ios8IntoVariable: function (name, params) {
        var newParams;
        if (!params) {
            newParams = {};
        } else {
            newParams = params;
        }
        if (newParams && typeof newParams === "string") {
            newParams = encodeURIComponent(newParams);
        } else {
            newParams = encodeURIComponent(JSON.stringify(newParams));
        }
        var ios8Ifr = document.getElementById("ios8Ifr");
        if (ios8Ifr) {
            ios8Ifr.parentNode.removeChild(ios8Ifr);
        }
        var iframe = document.createElement("iframe");
        iframe.src = "putaoapp://" + name + "=" + newParams;
        iframe.id = "ios8Ifr";
        iframe.style.display = "none";
        iframe.style.width = 0;
        iframe.style.height = 0;
        document.body.appendChild(iframe);
    },

    // 隐藏 app 的返回
    hiddenBackButton: function () {
        var that = this;
        if (window.hiddenBackButton) {
            window.hiddenBackButton();
        } else if (window.android && window.android.hiddenBackButton) {
            window.android.hiddenBackButton();
        } else if (window.webkit && window.webkit.messageHandlers) {
            that.ios8IntoVariable("hiddenBackButton");
        }
    },

    closeH5FromApp: function () {
        var that = this;
        if (window.closeH5FromApp) {
            window.closeH5FromApp();
        } else if (window.android && window.android.closeH5FromApp) {
            window.android.closeH5FromApp();
        } else if (window.webkit && window.webkit.messageHandlers) {
            that.ios8IntoVariable("closeH5FromApp");
        } else {
            window.history.back(-1);
        }
    },

    //判断微信
    isWeiXin: function () {
        if (ua.indexOf("micromessenger") > -1) { // ios和andoid通用判断微信
            return true;
        } else {
            return false;
        }
    },

    //判断阅读进阶VIP
    isPtadvancedvip: function () {
        if (ua.indexOf("ptadvancedvip") > -1 || this.getQueryString("advancedvip") === "1") { // ios和andoid通用判断
            return true;
        } else {
            return false;
        }
    },

    //判断是否是pc端
    isPc: function () {
        var userAgentInfo = navigator.userAgent.toLocaleLowerCase();
        var Agents = ["android", "iphone", "symbianos", "windows phone", "ipad", "ipod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        if (this.getQueryString("dev_debug")) {
            flag = true;
        }
        return flag;
    },

    /**
     * 生成UUID
     */
    generateUUID: function () {
        return 'xxxxxxxx-8xxx-yxxx-xxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16).toLocaleUpperCase();
        });
    },

    /**
     * 在微信中获取微信的openId
     */
    getWeixinOpenId: function (sucessCallback, failCallback) {
        var that = this;
        var wx_code = that.getQueryString("code");
        if (wx_code) {
            // 发送授权请求
            fetch(new Request("/course/weixin/v2/getOpenId/?code=" + wx_code, {
                method: "GET"
            }))
                .then(function (response) {
                    return response.json();
                })
                .then(function (res) {
                    if (res.openId) {
                        window.localStorage.setItem("openId", res.openId);
                        if (sucessCallback && typeof sucessCallback === "function") {
                            sucessCallback(res.openId);
                        }
                    } else {
                        if (failCallback && typeof failCallback === "function") {
                            failCallback();
                        }
                        try {
                            window.PTMonitor.report({
                                type: 'apiSucEx',
                                url: window.location.href,
                                info: "no openId",
                                stack: "/course/weixin/v2/getOpenId/?code=" + wx_code
                            }, window.EX_TYPE.apiSucEx);
                        } catch (err) { }
                    }
                })
                .catch(function (err) {
                    try {
                        window.PTMonitor.report({
                            type: 'apiEx',
                            url: window.location.href,
                            info: err,
                            stack: "/course/weixin/v2/getOpenId/?code=" + wx_code
                        }, window.EX_TYPE.apiEx);
                    } catch (err) { }
                });
        } else {
            window.location.href =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3ac95cbd0df1881d&redirect_uri=" +
                encodeURIComponent(window.location.href) + "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
        }
    },

    /**
    * app 新窗口打开
    * 
    * @param {object} urlObj app新窗口打开的参数对象
    * 
    */
    openNewPage: function (urlObj) {
        // openNewWebviewPage(JSON.stringify({
        //     "url": "https://...",
        //     "orientation": 1, //0表示和当前一致，1表示竖屏，2表示横屏   
        //     "isBlackStatus": 1 //安卓兼容水滴屏等状态栏信息 1显示 0不显示 默认是0
        //  }))
        var that = this;
        if (!urlObj && typeof urlObj !== 'object') {
            return;
        }

        if (window.openNewWebviewPage) {
            window.openNewWebviewPage(JSON.stringify(urlObj));
        } else if (window.android && window.android.openNewWebviewPage) {
            window.android.openNewWebviewPage(JSON.stringify(urlObj));
        } else if (window.webkit && window.webkit.messageHandlers) {
            // ios8 下不能包含 “=”， 所以直接改为 window.location.href
            if (urlObj.url && urlObj.url.indexof('=') > -1) {
                window.location.href = urlObj.url;
            } else {
                that.ios8IntoVariable("openNewWebviewPage", JSON.stringify(urlObj));
            }
        } else {
            window.location.href = urlObj.url;
        }
    },

    // 获取app当前版本
    getAppVersion: function () {
        var that = this;
        if (window.getAppVersion) {
            window.getAppVersion();
        } else if (window.android && window.android.getAppVersion) {
            window.android.getAppVersion();
        } else if (window.webkit && window.webkit.messageHandlers) {
            that.ios8IntoVariable("getAppVersion");
        }
    },

    // app比较版本是否相同 
    compareAppVersion: function (currentV, targetV) {
        //注： 版本相同返回true
        if ((currentV && typeof currentV === "string") && (targetV && typeof targetV === "string")) {
            var currentVArr = currentV.split(".");
            var targetVArr = targetV.split(".");
            var minLength = Math.min(currentVArr.length, targetVArr.length);
            for (var i = 0; i < minLength; i++) {
                if (currentVArr[i] !== targetVArr[i]) {
                    return parseInt(currentVArr[i], 10) > parseInt(targetVArr[i], 10);
                }
                if (i === minLength - 1) {
                    if (currentVArr.length >= targetVArr.length) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        } else {
            return false;
        }
    },

    // 转化app版本号 假定字符串的每节数都在5位以下
    toNum(a) {
        let b = a.toString();
        //也可以这样写 var c=a.split(/\./);
        let c = a.split('.');
        let num_place = ["", "0", "00", "000", "0000"], r = num_place.reverse();
        for (let i = 0; i < c.length; i++) {
            let len = c[i].length;
            c[i] = r[len] + c[i];
        }
        let res = c.join('');
        return res;
    },

    // app比较版本大小
    cprVersion(a, b, type) {
        let _a = utils.toNum(a),
            _b = utils.toNum(b);
        switch (type) {
            case ">":
                return _a > _b;
            case "<":
                return _a < _b;
            case ">=":
                return _a >= _b;
            case "<=":
                return _a <= _b;
            default:
                return _a == _b;
        }
        // if (_a == _b) console.log("版本号相同！版本号为：" + a);
        // if (_a > _b) console.log("版本号" + a + "是新版本！");
        // if (_a < _b) console.log("版本号" + b + "是新版本！");
    },

    //微信图片分享协议
    weChatShare: function (shareObj) {
        //weChatShare(JSON.stringify({
        //     "session": 0, //0表示好友，1表示朋友圈
        //     "imgUrl": "https://...", 分享小图地址 或者图片类型时的图片地址
        //     "shareType": 1, //1表示分享图片类型，其他正常页面分享
        //     "title": "步步ABC", // 标题
        //     "desc": "", //描述
        //     "link": "", //落地页地址
        // }))
        var that = this;
        var string_shareObj = JSON.stringify(shareObj);
        if (window.weChatShare) {
            window.weChatShare(string_shareObj);
        } else if (window.android && window.android.weChatShare) {
            window.android.weChatShare(string_shareObj);
        } else if (window.webkit && window.webkit.messageHandlers) {
            that.ios8IntoVariable("weChatShare".string_shareObj);
        }
    },

    //跳转至课程步骤页面
    gotoCourseDetail: function (paramsObj) {
        // var paramsAppObj = {
        //     "cid": appoint_cid
        // }
        var that = this;
        var string_paramsObj = JSON.stringify(paramsObj);
        if (window.gotoCourseDetail) {
            window.gotoCourseDetail(string_paramsObj);
        } else if (window.android && window.android.gotoCourseDetail) {
            window.android.gotoCourseDetail(string_paramsObj);
        } else if (window.webkit && window.webkit.messageHandlers) {
            that.ios8IntoVariable("gotoCourseDetail", string_paramsObj);
        }
    },

    //判断app  KidLearning_InApp_iOS , KidLearning_InApp_Android(安卓ua), kidlearning_inapp_web (electron)
    isApp: function () {
        var ua = navigator.userAgent.toLocaleLowerCase();
        if (ua.indexOf("kidlearning_inapp") > -1 && ua.indexOf("kidlearning_inapp_web") === -1) {
            return true;
        } else if (window.closeH5FromApp) {
            return true;
        } else {
            return false;
        }
    },

    /**
     * 设置某个cookie的值
     * @param {string} key cookie的名称
     * @param {string} value cookie的值
     * @param {integer} [hours] 超时时间  如果不提供cookie的随浏览器进程存在，浏览器关闭则cookie失效
     * @param domain
     * @param path
     * @return {string} cookie信息
     * 
     * 注：encode 过
     */
    setCookie: function (name, value, hours, domain, path) {
        var expire = '';

        if (hours instanceof Date) {
            expire = '; expires=' + hours.toGMTString();
        } else if (hours != null) {
            expire = new Date((new Date()).getTime() + hours * 3600000);
            expire = '; expires=' + expire.toGMTString();
        }

        if (typeof domain === 'undefined') {
            domain = '';
        } else {
            domain = '; domain=' + (domain.indexOf('putaoabc.com') > -1 ? '.putaoabc.com' : (domain.indexOf('putaoabc.net.cn') > -1 ? ".putaoabc.net.cn" : (domain.indexOf('bubuaike.com') > -1 ? '.bubuaike.com' : domain)));
        }

        if (typeof path === 'undefined') {
            path = '';
        } else {
            path = '; path=' + path;
        }

        document.cookie = name + '=' + encodeURIComponent(value) + expire + domain + path;
    },

    /**
    * 获取某个cookie的值
    * @param {string} key cookie的名称
    * @return {string} cookie值
    * 
    * 注：decode 过
    */
    getCookie: function (key) {
        key = encodeURIComponent(key);
        var cookies = document.cookie.split(';');
        for (var i = 0, len = cookies.length; i < len; i++) {
            var parts = cookies[i].split('='),
                name = decodeURIComponent(parts.shift()),
                cookie = parts.join('=');

            if (key === name.replace(/^\s+|\s+$/g, '')) {
                try {
                    return decodeURIComponent(cookie);
                } catch (e) {
                    //兼容历史base库中用escape编码的cookie
                    cookie = unescape(cookie);
                    return cookie;
                }
            }
        }
        return '';
    },

    /**
     * 删除cookie
     * @param {string} key cookie名称
     * @param domain
     * @param path
     */
    delCookie: function (name, domain, path) {
        var expire = '; expires=Mon, 26 Jul 1997 05:00:00 GMT';

        if (typeof domain === 'undefined') {
            domain = '';
        } else {
            domain = '; domain=' + (domain.indexOf('putaoabc.com') > -1 ? '.putaoabc.com' : domain);
        }

        if (typeof path === 'undefined') {
            path = '';
        } else {
            path = '; path=' + path;
        }

        document.cookie = name + '=' + expire + domain + path;
    },

    //获取uuid
    getUUID: function () {
        return 'xxxxxxxx-8xxx-yxxx-xxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16).toLocaleUpperCase();
        });
    },

    //判断图片是否存在
    CheckImgExists(imgurl) {
        return new Promise((resolve, reject) => {
            var ImgObj = new Image();
            ImgObj.src = imgurl;
            ImgObj.onload = function () {
                resolve()
            }
        })
    },

    //节流 防抖 
    throttle(fn, ms) {
        let timeout = null;
        let canScroll = true; // 通过闭包保存一个标记
        return function () {
            if (!canScroll) return; // 在函数开头判断标记是否为true，不为true则return
            canScroll = false; // 立即设置为false
            clearTimeout(timeout);
            timeout = setTimeout(() => { // 将外部传入的函数的执行放在setTimeout中
                fn.apply(this, arguments);
                /* 最后在setTimeout执行完毕后再把标记设置为true(关键)表示可以执行下一次循环了。
                当定时器没有执行的时候标记永远是false，在开头被return掉 */
                canScroll = true;
            }, ms);
        };
    },

    /**
     * 解决 ios微信内页面 存在独立滚动区域 滑到顶部继续往上滑动 或 滑到底部继续往下滑动 导致页面卡死 的问题
     * （页面整体滑动不存在此问题）
     * 
     * @param {string} className 独立滚动区域的类名，如不传特殊类名默认用scroll-content（同时需要在自己页面里给这个div加上class="scroll-content"）
     * @param {string} id 独立滚动区域的id ，可不传，如果传id优先使用id来获取独立滚动区域
     */
    preventFreezeAtTopOrBottomForIOS(className, id) {
        let classname = className ? className : "scroll-content";
        let contentEle = document;
        let lastY = 0; // Needed in order to determine direction of scroll.
        //获取滚动元素
        let scrollEle = id ? contentEle.getElementById(id) : contentEle.getElementsByClassName(classname)[0];
        scrollEle.addEventListener('touchstart', function (event) {
            lastY = event.touches[0].clientY;
        });
        //先移除监听事件
        scrollEle.removeEventListener('touchmove', function (event) {
            event.preventDefault();
        }, false);
        //再添加监听事件
        scrollEle.addEventListener('touchmove', function (event) {
            let top = event.touches[0].clientY;
            // Determine scroll position and direction.
            let scrollTop = scrollEle.scrollTop;
            // console.log("--scrollTop--" + scrollTop);
            let scrollHeight = scrollEle.scrollHeight;
            // console.log("--scrollHeight--" + scrollHeight);
            let clientHeight = scrollEle.clientHeight;
            // console.log("--clientHeight--" + clientHeight);
            let direction = (lastY - top) < 0 ? "up" : "down";
            // FIX IT!
            if (scrollTop === 0 && direction === "up") {
                console.log("--到顶部--");
                // Prevent scrolling up when already at top as this introduces a freeze.

                event.preventDefault();

            } else if (scrollTop >= (scrollHeight - clientHeight) && direction === "down") {
                // Prevent scrolling down when already at bottom as this also introduces a freeze.
                event.preventDefault();
                console.log("--到底部--");
            }
            lastY = top;
        });
    },

    /**
     * 获取一个随机整数
     * @param {number} number 整数的位数(默认是四位)
     */
    getRandom(number) {
        if (!number) {
            number = 4;
        }

        return parseInt(Math.random() * Math.pow(10, number), 10);
    },

    /**
     * 保持屏幕常亮
     * @param {String} type 1-常亮 0-解除常亮
     */
    setKeepScreenOn(type = '1') {
        if (window.setKeepScreenOn) {
            window.setKeepScreenOn(type);
        } else if (window.android && window.android.setKeepScreenOn) {
            window.android.setKeepScreenOn(type);
        }
    },

    /**
     * 是否是VIP外教。同时添加 favicon
     */
    isVipBingo: function () {
        var isVipBingo = window.location.pathname.indexOf("/bingo/vip_course/") > -1 || window.location.href.indexOf("=vipbingo") > -1 || window.location.hostname.indexOf("www.aibingo.com.cn") > -1 ? true : false;
        var favicon_icon = document.getElementById("favicon_icon");
        if (isVipBingo) {
            favicon_icon && (favicon_icon.href = "https://webres.putaoabc.com/course/images/common/vip_course/favicon.png");
        } else {
            favicon_icon && (favicon_icon.href = "https://webres.putaoabc.com/course/images/common/favicon.png");
        }
        return isVipBingo;
    },

    /**
     * 移除app的加载load
     */
    removeLoadingView: function () {
        if (window.removeLoadingView) {
            window.removeLoadingView();
        } else if (window.android && window.android.removeLoadingView) {
            window.android.removeLoadingView();
        }
    },

    /**
     * 针对看一看、读一读、课后作业 APP端做的加载页面，移除加载
     */
    loadingCompleted: function () {
        if (window.loadingCompleted) {
            window.loadingCompleted();
        } else if (window.android && window.android.loadingCompleted) {
            window.android.loadingCompleted();
        }
    },

    /**
     * 设置背景色 #FFFFFF
     */
    setBackgroundColor: function (value) {
        if (window.setBackgroundColor) {
            window.setBackgroundColor(value);
        } else if (window.android && window.android.setBackgroundColor) {
            window.android.setBackgroundColor(value);
        }
    },
    /**
     * 判断是否是 ios10及以下版本
     */
    isIos10Fun: function () {
        const versionStr = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        if (versionStr && Array.isArray(versionStr) && versionStr[1]) {
            const version = parseInt(versionStr[1], 10);
            if (version <= 10) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
}

utils.H5PlayAudio = h5PlayAudio;
utils.getAsyncResult = getAsyncResult;
utils.showCommonLoading = showCommonLoading;
utils.hideCommonLoading = hideCommonLoading;
utils.getPosterAjax = getPosterAjax;
utils.callApp = callApp;
utils.showTips = showTips;
utils.hideTips = hideTips;
utils.publicVar = publicVar;   // 通用变量
utils.putaoBuy = putaoBuy;    // 通用购买

export default utils;



// WEBPACK FOOTER //
// ./src/lib/utils.js